module.exports = __webpack_public_path__ + "google-play-badge.svg";